export default "__VITE_ASSET__Bb4E1J5I__"